import React from 'react';
import { Box, Typography, Container, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const TermsOfService = () => {
  const theme = useTheme();
  return (
    <Box sx={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0a1833 0%, #1a2238 100%)',
      py: { xs: 2, sm: 4, md: 6 },
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: { xs: 'center', md: 'flex-start' },
        justifyContent: 'center',
        width: '100%',
        maxWidth: '1100px',
        gap: { xs: 2, md: 6 },
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: { xs: 2, md: 0 } }}>
        <Button href="/" sx={{ minWidth: 0, p: 0, borderRadius: '50%', bgcolor: 'transparent', boxShadow: 'none', '&:hover': { bgcolor: 'rgba(0,0,0,0.08)' } }}>
          <img src="gtt-logo.png" alt="Home"
            style={{
              height: 'auto',
              width: '100%',
              maxWidth: '240px',
              marginBottom: 8,
              display: 'block',
            }}
            sizes="(max-width: 600px) 80px, (max-width: 900px) 120px, 240px"
          />
        </Button>
      </Box>
      <Container maxWidth="md" sx={{
        background: 'rgba(10,24,51,0.85)',
        borderRadius: 4,
        boxShadow: '0 8px 32px 0 rgba(0,0,0,0.25)',
        p: { xs: 2, sm: 4, md: 6 },
        color: '#fff',
      }}>
        <Typography
          variant="h3"
          gutterBottom
          sx={{
            fontWeight: 900,
            textTransform: 'uppercase',
            color: '#fff',
            letterSpacing: '0.04em',
            mb: 2,
            fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' },
            textAlign: { xs: 'center', md: 'left' },
            wordBreak: 'break-word',
          }}
        >
          Terms of Service
        </Typography>
        <Typography variant="body1" paragraph sx={{ color: '#fff' }}>
          Effective date: July 14, 2025
        </Typography>
        <Typography variant="body1" paragraph sx={{ color: '#fff' }}>
          Welcome to GT Telemetry. By accessing or using our web application, you agree to be bound by these Terms of Service. Please read them carefully.
        </Typography>
        <Typography variant="h5" gutterBottom sx={{ color: '#fff', mt: 4 }}>
          Use of Service
        </Typography>
        <Typography variant="body1" paragraph sx={{ color: '#fff' }}>
          You may use GT Telemetry for your personal, non-commercial use. You agree not to misuse the service or help anyone else do so. You are responsible for your activity and any content you upload.
        </Typography>
        <Typography variant="h5" gutterBottom sx={{ color: '#fff', mt: 4 }}>
          User Content
        </Typography>
        <Typography variant="body1" paragraph sx={{ color: '#fff' }}>
          You retain ownership of any data or content you upload. By uploading, you grant us a license to use, store, and process your content as needed to provide the service. You must not upload illegal, harmful, or infringing content.
        </Typography>
        <Typography variant="h5" gutterBottom sx={{ color: '#fff', mt: 4 }}>
          Account and Security
        </Typography>
        <Typography variant="body1" paragraph sx={{ color: '#fff' }}>
          You are responsible for maintaining the security of your account and any activity that occurs under your credentials. Notify us immediately of any unauthorized use.
        </Typography>
        <Typography variant="h5" gutterBottom sx={{ color: '#fff', mt: 4 }}>
          Disclaimer and Limitation of Liability
        </Typography>
        <Typography variant="body1" paragraph sx={{ color: '#fff' }}>
          The service is provided "as is" and "as available" without warranties of any kind. We are not liable for any damages or losses resulting from your use of the service.
        </Typography>
        <Typography variant="h5" gutterBottom sx={{ color: '#fff', mt: 4 }}>
          Changes to Terms
        </Typography>
        <Typography variant="body1" paragraph sx={{ color: '#fff' }}>
          We may update these Terms of Service from time to time. Continued use of the service after changes means you accept the new terms.
        </Typography>
        <Typography variant="h5" gutterBottom sx={{ color: '#fff', mt: 4 }}>
          Governing Law
        </Typography>
        <Typography variant="body1" paragraph sx={{ color: '#fff' }}>
          These terms are governed by the laws of your country or region, without regard to conflict of law principles.
        </Typography>
        <Typography variant="h5" gutterBottom sx={{ color: '#fff', mt: 4 }}>
          Contact
        </Typography>
        <Typography variant="body1" paragraph sx={{ color: '#fff' }}>
          If you have any questions about these Terms, contact us at contact@gt-telemetry.com.
        </Typography>
      </Container>
    </Box>
  </Box>
  );
};

export default TermsOfService;
